import { FC } from 'react';
import { getColorValue } from '@shinetools/sunshine';

import { activeDot } from 'features/Dashboard/common';

interface CustomCurrentAreaDotProps {
  cx?: number;
  cy?: number;
}

const CustomCurrentAreaDot: FC<CustomCurrentAreaDotProps> = ({ cx, cy }) => {
  if (cx === undefined || cy === undefined) {
    return null;
  }

  return (
    <svg {...activeDot('grey.800')} x={cx - 6} y={cy - 6}>
      <g transform="translate(6 6)">
        <circle fill={getColorValue('grey.800')} r="5" />
        <circle fill="white" r="5" />
      </g>
    </svg>
  );
};

export default CustomCurrentAreaDot;
